import { ReactNode } from "react";

export function AdminHeader({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="text-xs font-black uppercase tracking-[0.18em] text-[#C89B5C]">SellerSupply Shop</p>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-[#0F172A] md:text-4xl">{title}</h1>
        {description ? <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function AdminCard({ title, children, className = "" }: { title?: string; children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-[28px] border border-[#0F172A]/10 bg-white p-5 shadow-[0_22px_60px_rgba(15,23,42,0.07)] ${className}`}>
      {title ? <h2 className="mb-4 text-lg font-black">{title}</h2> : null}
      {children}
    </section>
  );
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return <label className="grid gap-2 text-sm font-bold text-slate-700"><span>{label}</span>{children}</label>;
}
